import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { AppInput, AppRemixIcon } from '@/layout/AppComponents';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import AuxSidebar from '../../../../../../Sidebar/AuxSidebar';
import Translator from '../../../../../../components/helpers/Translator';
import useIsMounted from '../../../../../../components/hooks/useIsMounted';

const PlantManagerSideBarBlock = () => {
  const dispatch = useDispatch();
  const { moduleBridgeHex, plantHex } = useParams();
  const isMounted = useIsMounted();
  const [plantManagers, setPlantManagers] = useState();
  const [isPlantManagersLoaded, setIsPlantManagersLoaded] = useState(false);
  const [editingPlantManagerIndex, setEditingPlantManagerIndex] = useState(
    false
  );
  const [openOnce, setOpenOnce] = useState(false);
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );

  // > LOAD PLANT INFORMATION
  useEffect(() => {
    (async () => {
      try {
        const response = await axios.post(
          axiosPath(
            "api_r_user_module_legalCompliance_evaluation_getPlantManagers"
          ),
          { moduleBridgeHex, plantHex }
        );
        if (isMounted.current) {
          setPlantManagers(response.data);
          setIsPlantManagersLoaded(true);
        }
      } catch (err) {}
    })();
  }, []);
  // < LOAD PLANT INFORMATION

  // > EDIT INPUT
  useEffect(() => {
    const handler = setTimeout(() => {
      if (isPlantManagersLoaded) {
        (async () => {
          try {
            await axios.post(
              axiosPath(
                "api_r_user_module_legalCompliance_evaluation_setPlantManagers"
              ),
              { moduleBridgeHex, plantHex, plantManagers }
            );
            if (isMounted.current) setEditingPlantManagerIndex(null);
          } catch (err) {}
        })();
      }
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [plantManagers]);

  const handleOnChangeInput = (v, index) => {
    const updatedPlantManagers = [...plantManagers];
    updatedPlantManagers[index].value = v;
    setPlantManagers(updatedPlantManagers);
    setEditingPlantManagerIndex(index);
  };
  // < EDIT INPUT

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== 'plantManagers')
      dispatch(
        currentPageAction.change('auxSidebar', { opened: 'plantManagers' })
      );
    else dispatch(currentPageAction.change('auxSidebar', { opened: null }));
  };

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'plantManagers' ? 'active' : ''}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="group" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator
              file="module-legalCompliance"
              name="plant.manager.short"
            />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={
          <Translator file="module-legalCompliance" name="plant-managers" />
        }
        isOpen={auxSidebar && auxSidebar === 'plantManagers'}
        width="350px"
        position="right"
        onClose={() => handleAuxSidebar()}
      >
        {openOnce && (
          <>
            {plantManagers && plantManagers.length > 0 ? (
              plantManagers.map((pm, index) => (
                <AppInput
                  key={index}
                  type="text"
                  title={pm.name}
                  icon={
                    <AppRemixIcon
                      icon={
                        editingPlantManagerIndex === index ? 'loader-4' : 'user'
                      }
                    />
                  }
                  value={pm.value}
                  onChange={(v) => handleOnChangeInput(v, index)}
                  isClearable
                />
              ))
            ) : (
              <div className="alert alert-light">
                <Translator
                  file="module-legalCompliance"
                  name="empty.plant.managers"
                />
              </div>
            )}
          </>
        )}
      </AuxSidebar>
    </>
  );
};

export default PlantManagerSideBarBlock;
